import { call, fork, put, take } from 'redux-saga/effects';
import api from 'services';
import * as actionTypes from 'constants/ActionTypes';

/**
 * Get cargo types
 * */
function* getCargoTypes() {
    const response = yield call(api.getCargoTypes);
    if (response.status === 200) {
        yield put({
            type: actionTypes.GET_CARGO_TYPES.SUCCESS,
            data: response.data,
        });
        return;
    }

    yield put({
        type: actionTypes.GET_CARGO_TYPES.FAILURE,
        errors: response.errors,
    });
}

export function* watchGetCargoTypes() {
    while (true) {
        yield take(actionTypes.GET_CARGO_TYPES.REQUEST);
        yield fork(getCargoTypes);
    }
}

export default [
    watchGetCargoTypes,
];





// WEBPACK FOOTER //
// ./app/sagas/cargoes/types.js